<div class="avatar-input">
  <app-avatar (click)="onAvatarClick()"
              [avatar]="avatar"
              [ngClass]="{pointer: !disabled}"></app-avatar>

  <input #input
         *ngIf="!disabled"
         type="file"
         class="avatar-input__input"
         accept="image/*"
         (change)="onFileChange($event)"/>

  <ng-template #imageCrop>
    <div class="avatar-input__img-crop-wrapper">
      <image-cropper
        class="avatar-input__img-crop"
        [imageChangedEvent]="imgChangeEvt"
        [maintainAspectRatio]="true"
        format="png"
        (imageCropped)="cropImg($event)">
      </image-cropper>

      <app-button (click)="saveCropImg()">Crop</app-button>
    </div>
  </ng-template>
</div>
